import ReportPage from "components/Reports/Pages/SingleReport";

function Report() {
    return (
        <>
            <ReportPage isStandalone={true} />
        </>
    )
}

export default Report;
